import OProjectNav from './o-project-nav.vue'

export default OProjectNav
